import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoErrorsDetailsComponent } from './errors-details/errors-details.component';
import { AvanoErrorsPopoverDirective } from './errors-details/errors-popover.directive';
import { ExampleValidationErrorsService, ValidationErrorsService } from './validation-errors-service';
import { AvanoValidationErrorSupportDirective } from './validation-errors-support.directive';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  imports: [CommonModule, TranslateModule.forChild({ extend: true })],
  declarations: [AvanoErrorsDetailsComponent, AvanoErrorsPopoverDirective, AvanoValidationErrorSupportDirective],
  exports: [AvanoErrorsDetailsComponent, AvanoErrorsPopoverDirective, AvanoValidationErrorSupportDirective],
  providers: [
    {
      provide: ValidationErrorsService,
      useExisting: ExampleValidationErrorsService
    }
  ]
})
export class ValidationModule {}
